import { render } from "./BourseDossardsListListeAttente.vue?vue&type=template&id=589dd2a1"
import script from "./BourseDossardsListListeAttente.vue?vue&type=script&lang=js"
export * from "./BourseDossardsListListeAttente.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__